import React from 'react';
/* eslint-disable */
import { SubHeading } from '../../components';
import { images, data } from '../../constants';
import './Laurels.css';


const AwardCard = ({ award: { imgUrl, subtitle, subtitle2, subtitle3 } }) => (
  
  <div className="app__laurels_awards-card">

    <div className="app__laurels_awards-card_content">

      <ul style={{listStyle:"none"}}>
        <li className="p__opensans">{subtitle} 🚚</li>
        <li className="p__opensans">{subtitle2} 🛵</li>
        <li className="p__opensans">{subtitle3} 🍽️</li>
      </ul>
  
   
    </div>
  </div>
);


const Laurels = () => {



return(
  <div className="app__bg app__wrapper section__padding" id="awards">
    <div className="app__wrapper_info">
      <SubHeading title="Volcano Oasis" />
      <h1 className="headtext__cormorant"  >Nos zones de livraison</h1>
      <p className="p__opensans">Poussez Les Portes De Nos Deux Restaurants Volcano D'où Que Vous Veniez D'un Rayon De 20 Km Autour De Mans :</p>
      <p className="p__opensans">Veuillez Noter Que La Livraison est à partir de 20 euros </p>
      <div className="app__laurels_awards">
        {data.awards.map((award) => <AwardCard award={award} key={award.title} />)}
      </div>
    </div>

    <div className="app__wrapper_img">
      <img className="img__livraison" src={images.delivery} alt="laurels_img" />
    </div>
  </div>
)};

export default Laurels;
